// import { baseUrl, baseUrlServices } from "../shared/baseUrl";

// export const requestGet = async (serviceName, enableToken = true) => {

//     try  {

//         const headers = new Headers();
//         headers.append('Authorization', `Bearer ${JSON.parse(localStorage.getItem('user_store_ecommerce'))}`);

//         const responseGet = await fetch(baseUrl.concat(serviceName), { headers});
//         const response = await responseGet.text();
//         return response;

//     } catch (error) {
//         console.log(error);
//     }

// }

import { baseUrlServices } from "../shared/baseUrl";

export const requestGet = async (serviceName, enableToken = true) => {
    try {
        // Configuración de los headers
        const headers = new Headers();
        
        // Agregar el token solo si enableToken es true
        if (enableToken) {
            const token = JSON.parse(localStorage.getItem('user_store_ecommerce'));
            if (token) {
                headers.append('Authorization', `Bearer ${token}`);
            } else {
                console.warn("Token not found in localStorage");
            }
        }
        console.log(baseUrlServices.concat(serviceName))
        // Realizar la petición
        const responseGet = await fetch(baseUrlServices.concat(serviceName), { headers });

        // Verificar si la respuesta es exitosa
        if (!responseGet.ok) {
            throw new Error(`Error ${responseGet.status}: ${responseGet.statusText}`);
        }

        // Intentar convertir la respuesta a JSON
        try {
            const data = await responseGet.json();
            return data;
        } catch (error) {
            // Si la respuesta no es JSON, devolver el texto
            const text = await responseGet.text();
            return text;
        }

    } catch (error) {
        console.error("Fetch error:", error);
        throw error; // Propagar el error para que pueda ser manejado externamente si es necesario
    }
};